import { render, staticRenderFns } from "./studentClub.vue?vue&type=template&id=6cc958f1"
import script from "./studentClub.vue?vue&type=script&lang=js"
export * from "./studentClub.vue?vue&type=script&lang=js"
import style0 from "./studentClub.vue?vue&type=style&index=0&id=6cc958f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports